import React, { useContext, useEffect, useState } from "react";
import { EmpdContext } from "../../Context";

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const NoMatch = () => {
  const context = useMyContext()

  return (
    <div>
        The content you requested can't be found
    </div>
  )
};

export default NoMatch;
